<template>
  <main class="">
    <event :events="events"/>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import event from '../../components/Pages/Journal/event'
  import {mapMutations, mapState, mapGetters, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";

  export default {
    name: 'JournalItemPage',
    mixins: [tokenAndRoute, loaderMixin],
    components: { event },
    computed: {
      ...mapState({
        eventsData: state => state.journal.events,
        selectedType: state => state.journal.selectedType,
        selectedDevice: state => state.journal.selectedDevice
      }),
      id() {
        return this.$route.params.id
      },
      events() {
        // сортируем по дате создания
        let arr = [ ...this.eventsData ];
        arr.sort((a, b) => {
          if (a.created_at > b.created_at) {
            return -1
          }
          if (a.created_at < b.created_at) {
            return 1
          }
          return 0
        })
        // сортируем по вещи
        return arr.filter(item => {
          if (this.selectedDevice.value !== '') {
            return item.source_device_id == this.selectedDevice.value;
          }
          return true
        })
      }
    },
    methods: {
      ...mapActions({
        getEvents: 'journal/getEvents',
        getDevice: 'things/getDevice',
        getEventTypes: 'journal/getEventTypes',

      }),
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      })
    },
    beforeRouteEnter(to, from, next) {
      next(async (vm) => {
        vm.showLoader();
        await vm.getEvents({id: vm.routeId});
        await vm.getDevice(vm.routeId);
        vm.getEventTypes(vm.routeId);

        vm.setFullSidebar(false);
        vm.setLinkName('journals');
        vm.setRouteName('');

        vm.hideLoader()
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
